<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" @click="goBack">{{ $t('message.orderTracking') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="row justify-content-center">
        <div class="col-lg-12 bg-white py-4">
          <div class="container mt-4 pt-4">
            <div v-for="(order, index) in pageOrders" :key="index" class="row">
              <tracking-component :order="order" :store="currentStoreDoc"></tracking-component>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
            <div v-if="pageOrders.length == 0">
              <message message="No order available" />
            </div>
          </div>
          <div class="text-center">
            <button
              v-if="orders.length != pageOrders.length"
              class="btn btn-info"
              :style="mobileStyles.btn"
              @click="moreCallback()"
            >More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/orderTracking.js";
import Message from "./../shared/Message";
import TrackingComponent from "./partials/trackingComponent";
export default {
  components: {
    Message,
    TrackingComponent
  },

  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false
    };
  },
  computed: {
    ...mapGetters(["user", "currentstore", "mobileStyles", "currentStoreDoc"])
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.currentstore }
      });
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    ...shared.methods
  }
};
</script>

